/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { FaFilePdf, FaFileExcel } from "react-icons/fa";
import { exportToPdf, exportToExcel } from "../../utils/exportReport";
import { showToast } from "./Toast&Alerts";

// Export PDF / Excel of the list currently on screen (client-side, see utils/exportReport.js).
// Usage --> <ExportButtons columns={columns} data={list} getMeta={() => ({ title, filters, summary, fileName })} />
// Columns with JSX renders should provide exportValue(val, row); amount columns can set numeric: true.
// Icon-only, outlined export button (PDF red / Excel green); the name shows as its tooltip
export const ExportIconButton = ({ type, onClick, disabled = false, busy = false }) => {
    const label = type === "pdf" ? "Export PDF" : "Export Excel";
    return (
        <button type="button" className={`btn btn-export btn-export-${type}`} title={busy ? "Exporting..." : label} aria-label={label}
            onClick={onClick} disabled={disabled || busy}>
            {busy ? <span className="spinner-border spinner-border-sm" /> : type === "pdf" ? <FaFilePdf size={17} /> : <FaFileExcel size={17} />}
        </button>
    );
};

const ExportButtons = ({ columns, data, getMeta, disabled = false }) => {
    const [exporting, setExporting] = useState(null);

    // Action / button columns have nothing to export
    const exportColumns = columns.filter((c) => c.dataIndex && c.exportable !== false);

    const handleExport = async (type) => {
        if (!data?.length) {
            showToast("warning", "No data to export");
            return;
        }
        try {
            setExporting(type);
            const meta = getMeta();
            const rows = [...data].reverse(); // MainTable displays its dataSource reversed; keep file order = screen order
            if (type === "pdf") await exportToPdf(exportColumns, rows, meta);
            else await exportToExcel(exportColumns, rows, meta);
        } catch (err) {
            showToast("error", "Export failed");
        } finally {
            setExporting(null);
        }
    };

    return (
        <>
            <ExportIconButton type="pdf" onClick={() => handleExport("pdf")} disabled={disabled || !!exporting} busy={exporting === "pdf"} />
            <ExportIconButton type="excel" onClick={() => handleExport("excel")} disabled={disabled || !!exporting} busy={exporting === "excel"} />
        </>
    );
};

export default ExportButtons;
